import gql from 'graphql-tag';

export const deleteMOCEvent = gql`
  mutation deleteMOCEvent($id: String!) {
    deleteMOCEvent(id: $id)
  }
`;
